import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from 'shared';
import { CourseCatalogResponse } from './program-catalog.models';

/**
 * Program Catalog (Wolfpack Assets / domain 7). Fetches the course catalog in a
 * given UI language with per-user free/owned/accessible flags. Backend:
 * GET /api/course-catalog?locale=<lang> (Api::CourseCatalogController).
 */
@Injectable({ providedIn: 'root' })
export class ProgramCatalogService {
  private readonly apiUrl = this.environment.apiUrl || 'http://localhost:3000/api';

  constructor(private http: HttpClient, @Inject(ENVIRONMENT) private environment: any) {}

  getCatalog(locale: string): Observable<CourseCatalogResponse> {
    return this.http.get<CourseCatalogResponse>(`${this.apiUrl}/course-catalog`, { params: { locale } });
  }
}
